import React from 'react';
import {getCurrentPortalProp} from '@netx/core-cms-next/utils/getCurrentPortalProp';
import {useCategoryChildren} from '../../hooks';
import {CategoryCards} from './CategoryCards';

export interface CategoryCardsContainerProps {
	id: number;
}

export const CategoryCardsContainer = ({id}: CategoryCardsContainerProps) => {
	const {categories, loading} = useCategoryChildren({
		id,
	});
	return (
		<CategoryCards
			categories={categories}
			loading={loading}
			displayDescription={getCurrentPortalProp('displayCatDescriptions')}
		/>
	);
};
